import { render, staticRenderFns } from "./BusinessDailyDetail.vue?vue&type=template&id=61d38946&scoped=true&"
import script from "./BusinessDailyDetail.vue?vue&type=script&lang=js&"
export * from "./BusinessDailyDetail.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDailyDetail.vue?vue&type=style&index=0&id=61d38946&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d38946",
  null
  
)

export default component.exports